import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

export const mobileRedirectGuard: CanActivateFn = (route, state): boolean => {
  const deviceService = inject(DeviceDetectorService);

  // tránh loop nếu user đã ở external page quay lại
  // if (state.url.includes('download-app')) {
  //   return true;
  // }

  if (deviceService.isMobile()) {
    window.location.href = 'https://tammi.vn/download-app';
    return false; // 🚨 bắt buộc
  }

  return true;
};
